import dynamic from "next/dynamic";

export const DynamicHero016 = dynamic(() => import("./Hero016"), {
  suspense: true,
});
